import React, { Component } from 'react';
import { Mutation } from '@apollo/react-components';
import { gql } from '@apollo/client';
import { notification } from 'antd';
import queryString from 'query-string';
import Bounce from '$components/Bounce';
import AuthLayout from '$components/layout/AuthLayout';
import Seo from '$components/Seo';
import routes from '@achievable-me/tundra-wizard/routes';
import CURRENT_USER from '$queries/currentUser';
import storage from '$lib/storage';
import logger from '$lib/logger';
import SignInForm from './SignInForm';

const SIGN_IN = gql`
  mutation SignIn($input: SignInInput!) {
    signIn(input: $input) {
      email
      accessToken
      errors {
        detail
      }
    }
  }
`;

class SignIn extends Component {
  constructor(props) {
    super(props);

    const { location } = this.props;
    const { search, state } = location;

    // Two forms of return redirects, with ?returnTo=/foo
    //  or with <Redirect state={ from: { pathname } } />
    // 20200608JP: Not sure if ?returnTo is actually used.
    if (state && state.from) {
      const { from } = state;
      const { pathname, search: fromSearch, hash } = from;
      const returnTo = `${pathname}${fromSearch}${hash}`;
      logger.log('set returnTo via state', returnTo);
      storage.setReturnTo(returnTo);
    } else {
      const parsed = queryString.parse(search);
      const { returnTo: pathname } = parsed;
      if (pathname) {
        const returnTo = { returnTo: pathname };
        if (returnTo) {
          logger.log('set returnTo via query', returnTo);
          storage.setReturnTo(returnTo);
        }
      }
    }
  }

  render() {
    const { currentUser } = this.props;

    if (currentUser) {
      return <Bounce currentUser={currentUser} />;
    }

    return (
      <AuthLayout>
        <Seo
          title="Sign in"
          canonical={routes.auth.signIn}
          description="Sign in to your Achievable account."
        />
        <Mutation
          mutation={SIGN_IN}
          refetchQueries={[{ query: CURRENT_USER }]}
          update={(_cache, { data }) => {
            const { signIn } = data;
            if (!signIn || signIn.errors) {
              const description = signIn
                ? signIn.errors[0].detail
                : 'Please verify your credentials';
              notification.error({
                message: 'Unauthorized',
                description,
              });
              return;
            }
            const { email, accessToken } = signIn;
            storage.setAuth({ email, accessToken });
          }}
        >
          {(signIn, { loading }) => <SignInForm signIn={signIn} loading={loading} />}
        </Mutation>
      </AuthLayout>
    );
  }
}

export default SignIn;
